/**
 * Company: SPHMedia
 * Description: [Brief description of the component]
 */
import Divider from "@assets/divider.svg?react";
import FireGif from "@src/app/assets/lottie/popularfire_100.gif";
import type { BFFArticleCard } from "@src/app/types/bff";

import NumberedCard from "./NumberedCard";

type NumberedCardContainerProps = {
  // Define the type for the props required by the component (if any)
  list: BFFArticleCard[];
  title: string;
  className?: string;
  testId?: number | string;
};

/**
 * NumberedCard
 * Description: [Description of what the component does]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function NumberedCardContainer({
  list,
  title,
  className = "",
  testId,
}: NumberedCardContainerProps) {
  if (list.length === 0) return null;
  return (
    <div className={className}>
      <div
        data-testid={`numbered-card-container-${testId}`}
        className="flex flex-col bg-tertiary"
      >
        <div className="px-5 py-4">
          <div className="flex items-center gap-[8px] pb-[16px] ">
            <img src={FireGif} alt="Numbered Card" className="size-[22px]" />
            <h2 className="text-header-2 text-primary">{title}</h2>
          </div>
          <Divider className="!max-w-full" />
        </div>
        {list.map((article, index) => (
          <div key={index} className="px-5 pb-4">
            <NumberedCard article={article} index={index + 1} />
          </div>
        ))}
      </div>
    </div>
  );
}
